// @flow

const scrollTo = (x: number, y: number) => {
  if (typeof window !== 'undefined') {
    window.scrollTo(x, y);
  }
};

export const scrollToTop = () => scrollTo(0, 0);

export default scrollTo;
